import {
  createValidator,
  match,
  phoneRegex,
  required,
  streetAddressRegex,
  unitNumberRegex,
  zipCodeRegex,
  validDate,
  validateDateRange
} from '../../../../../util/form/validation';

export const validation = createValidator({
  'phoneNumber': match(
      phoneRegex,
      'Please enter a valid phone number'
  ),
  'streetAddress': match(
    streetAddressRegex,
    'Please enter a valid street address'
  ),
  'unitNumber': match(
    unitNumberRegex,
    'Please enter a valid unit number'
  ),
  'zipCode': match(
    zipCodeRegex,
    'Please enter a valid zip code'
  ),
  'serviceStopDate': [
    required('Please enter a valid date'),
    validDate('Please enter a valid date'),
    validateDateRange('The disconnect date')
  ]
});

export const fields = [
  'serviceStopDate',
  'phoneNumber',
  'streetAddress',
  'unitNumber',
  'zipCode'
];



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/localization/localizationHelpers.js
 **/